import { querySelectorAll } from '../helpers'

export function initializeDatepickers() {
  querySelectorAll<HTMLInputElement>('input[type="date"]').forEach(
    datepicker => {
      const { flatpickr } = window as any
      flatpickr(datepicker, {
        altInput: true,
        altFormat: 'F j, Y',
        dateFormat: 'Ymd',
      })
    }
  )
}
